import React from 'react'

function PrivacyPolicy() {
  return (
    <div className="legal-page">
        
        <h5>Last updated: August 1, 2025</h5>

<p>This Privacy Policy outlines how Amfia Education collects, uses, and protects any information that you provide while visiting our website or registering for our courses.</p>

<p>Amfia Education is committed to protecting your privacy. Any information you share with us will only be used in accordance with this policy.</p>

<p>We may update this policy from time to time, so please review it periodically.</p>

<h5> Information We Collect:</h5>
<p>We may collect the following details from you:</p>

<p>Name and contact information (email, phone number)</p>

<p>Student’s class, school, and academic interests</p>

<p>Feedback and responses through surveys or registration forms</p>

<h5> How We Use Your Information:</h5>
<p>We collect this data to:</p>

<p>Provide course access and updates</p>

<p>Share weekly performance reports with parents</p>

<p>Improve our classes and services</p>

<p>Send important updates, offers, or newsletters </p>

<p>We never sell or misuse your data.</p>

 <h5>Security of Your Information:</h5>
<p>We follow strict digital and physical security practices to protect your data from unauthorized access.</p>

<h5>Use of Cookies:</h5>
<p>We use cookies to improve your browsing experience and understand your interaction with our website. You can disable cookies through your browser settings if preferred.</p>

<h5>Controlling Your Data:</h5>
<p>You can:</p>

<p>Opt out of promotional emails anytime</p>

<p>Request correction or deletion of your data by emailing us at contact@amfiaeducation.com</p>

<p>We will never share your data with third parties without your permission, unless required by law.</p>

<h5> Contact Us:</h5>
<p>If you have any questions or concerns, reach out at:</p>
<p>📍 Sai Heights, SN. 83/1 Sai Park Road, Dighi, Pune, Maharashtra – 411015</p>
<p>📞 6392492293, 9559420174</p>
<p>✉️ contact@amfiaeducation.com</p>
        
    </div>
  )
}

export default PrivacyPolicy